import React, { useContext, useState } from 'react'
import './PortraitMenu.css'
import Header from './Header'
import SubHeader from './SubHeader'
import DisplaySearchItem from './DisplaySearchItem'
import ShowSelectPoint from './ShowSelectPoint'
import StartAndEndSearch from './StartAndEndSearch'
import { GVarState } from '../StoreState/Gstate'
import StepByStepMobile from './StepByStepMobile'
function PortraitMenu() {
    let g = useContext(GVarState);
    return (
        <div>
            <Header />
            {g.StartAndEndPart ? <StartAndEndSearch /> :
                <>
                    <SubHeader /> {/* search input hai isme */}
                    <DisplaySearchItem />{/* first time search hone pr jo result aata hai   */}
                    <ShowSelectPoint />
                </>
            }
            {g.path.length>1 && <StepByStepMobile />}
        </div>
    )
}

export default PortraitMenu